import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { buildYupLocale } from "validation";
import { urlFormat } from "./library/utils";

const defaultLanguage = "en-GB";

const phraseUrl = urlFormat(process.env.REACT_APP_PHRASE_BASE_URL || "");

// Language detector that starts with default and gets updated by AppSettingsProvider
const languageDetector = {
  type: "languageDetector" as any,
  async: true,
  detect: (callback: Function) => {
    // Start with default language - will be updated by AppSettingsProvider once settings load
    callback(defaultLanguage);
  },
  init: () => {},
  cacheUserLanguage: () => {},
};
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(Backend)
  .use(languageDetector)
  .init(
    {
      keySeparator: false,
      interpolation: {
        escapeValue: false,
      },
      load: "currentOnly",
      backend: {
        // for all available options read the backend's repository readme file
        loadPath: `${phraseUrl}/{{lng}}.json`,
      },
      fallbackLng: (code: string) => {
        if (!code || code === "en-US") return ["en-GB", "lv-LV"];

        if (code === "lv-LV") return ["lv-LV", "en-GB"];

        return ["en-GB", "lv-LV"];
      },
      saveMissing: true,

      missingKeyHandler: (lngs, _, key, fallbackValue) => {
        // Check if the key is available in 'en-GB', and if so, return its value

        if (lngs[1] === "en-GB") {
          return i18n.t(key, { lng: "en-GB" });
        }

        // If not found in 'en-GB', return the fallback value
        // console.warn(`Missing translation key: ${key}`);
        return fallbackValue;
      },
      supportedLngs: ["en-GB", "lv-LV"],
      postProcess: ["phraseInContextEditor"],
    },
    buildYupLocale
  );

export default i18n;
(window as any).i18n = i18n;
